import type { CSSProperties } from 'react';

const bodyPadding = 'var(--mb-padding, var(--mantine-spacing-md))';

/**
 * The KYC document drawers outgrow a short viewport. The drawer keeps its native (outer) scroll and
 * the Save/Cancel buttons stick to the bottom, bleeding into the body padding so scrolling content
 * can't peek out around them.
 */
export const drawerFooter: CSSProperties = {
	position: 'sticky',
	marginTop: '1rem',
	bottom: `calc(${bodyPadding} * -1)`,
	marginInline: `calc(${bodyPadding} * -1)`,
	marginBottom: `calc(${bodyPadding} * -1)`,
	padding: bodyPadding,
	backgroundColor: 'var(--mantine-color-body)',
};
